module.exports = __webpack_public_path__ + "ava_default.5f01d72231d1943e069522548549e8ed.png";